import { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const Index = () => {
  const [saleType, setSaleType] = useState([]);
  const Navigate = useNavigate();
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllSaleType(); }, []);

  const getAllSaleType = () => {
    get(`/sale-type`)
      .then((res) => setSaleType(res?.datas))
      .catch((err) => console.log(err));
  };

  const changeStatus = (id, status) => {
    post(`${baseURL}/sale-type/status`, { id, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSaleType(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (id) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the sale type.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/sale-type/delete`, { id })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSaleType(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    const reorderedItems = Array.from(saleType);
    const [movedItem] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, movedItem);
    setSaleType(reorderedItems);
    post(`/sale-type/update-sequence`, { items: reorderedItems })
      .then((res) => { if (res?.status) getAllSaleType(); else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = (align = 'left') => ({ padding: '12px 16px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: align, borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' });
  const tdS = (align = 'left') => ({ padding: '12px 16px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle', textAlign: align });

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Sale Types</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Drag rows to reorder</p>
          </div>
          <Link to="/admin/sale-type/add" style={{ textDecoration: 'none' }}>
            <button style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add Sale Type</button>
          </Link>
        </div>

        {/* Drag hint */}
        <div style={{ padding: '8px 24px', background: '#fffbeb', borderBottom: '1px solid #fef3c7', fontSize: 12, color: '#92400e', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>⇅</span> Drag rows to reorder sale types
        </div>

        <div style={{ overflowX: 'auto' }}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable-table">
              {(provided) => (
                <table style={{ width: '100%', borderCollapse: 'collapse' }} ref={provided.innerRef} {...provided.droppableProps}>
                  <thead>
                    <tr>
                      <th style={{ ...thS('center'), width: 50 }}>⇅</th>
                      <th style={{ ...thS('left'), minWidth: 260 }}>Name</th>
                      <th style={{ ...thS('center'), width: 120 }}>Status</th>
                      <th style={{ ...thS('center'), width: 140 }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {saleType?.length > 0 ? saleType.map((item, index) => (
                      <Draggable key={item._id} draggableId={item._id} index={index}>
                        {(provided) => (
                          <tr ref={provided.innerRef} {...provided.draggableProps}
                            onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                            <td style={{ ...tdS('center'), width: 50, cursor: 'grab' }} {...provided.dragHandleProps}>
                              <span style={{ color: '#c0c8d8', fontSize: 16 }}>⠿</span>
                            </td>
                            <td style={{ ...tdS('left'), fontWeight: 600, color: '#0a1628', minWidth: 260 }}>{item?.name}</td>
                            <td style={{ ...tdS('center'), width: 120 }}>{pill(item?.isActive)}</td>
                            <td style={{ ...tdS('center'), width: 140 }}>
                              <div style={{ display: 'flex', gap: 6, justifyContent: 'center', alignItems: 'center' }}>
                                <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {item?.isActive ? '✕' : '✓'}
                                </button>
                                <button onClick={() => Navigate(`/admin/sale-type/edit?${item._id}`)} title="Edit"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>✎</button>
                                <button onClick={() => deleteHandler(item._id)} title="Delete"
                                  style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    )) : (
                      <tr><td colSpan={4} style={{ ...tdS('center'), padding: '48px', color: '#9aa5c0' }}>No sale types found</td></tr>
                    )}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
